export default "__VITE_ASSET__8dd2993f__"